module.exports = __webpack_public_path__ + "img/costEffective.c871f74c.jpg";